import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import BottomModalV2, { RefProps } from "../common/BottomModalV2";
import List from "../common/List";
import PreviousNoticeListItem from "./PreviousNoticeListItem";
import { useNoticeListQuery } from "../../api/noticeAPI";

interface IPreviousNoticeListModalProps {
  onSelectNotice: (notice: any) => void;
}

const PreviousNoticeListModal = (props: IPreviousNoticeListModalProps, ref: React.Ref<RefProps>) => {
  const modalRef = useRef<RefProps>(null);

  // 공지사항 리스트 조회 (최신순 정렬, 첫 페이지만)
  const { data: noticeListData, isLoading, refetch } = useNoticeListQuery(
    { sortBy: "insert_date:DESC", page: 1 }
  );

  useImperativeHandle(ref, () => ({
    modalOpen: () => {
      modalRef.current?.modalOpen();
      refetch(); // 모달 열 때 데이터 새로 가져오기
    },
    modalClose: () => modalRef.current?.modalClose(),
  }));

  const handleSelectNotice = (notice: any) => {
    props.onSelectNotice(notice);
    modalRef.current?.modalClose();
  };

  const handleClose = () => {
    return true; // 닫기 허용
  };

  const handleConfirm = () => {
    // 선택 없이 닫기
  };

  return (
    <BottomModalV2
      ref={modalRef}
      modalTitle="이전 공지사항 목록"
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <List pd="0 15px">
        {isLoading ? (
          <LoadingContainer>로딩 중...</LoadingContainer>
        ) : noticeListData?.data?.data?.length > 0 ? (
          noticeListData.data.data.map((notice: any, index: number) => (
            <PreviousNoticeListItem
              key={index}
              notice={notice}
              onSelect={handleSelectNotice}
            />
          ))
        ) : (
          <NoDataContainer>공지사항이 없습니다.</NoDataContainer>
        )}
      </List>
    </BottomModalV2>
  );
};

const LoadingContainer = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.color.tertiary};
`;

const NoDataContainer = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.color.tertiary};
`;

export default forwardRef(PreviousNoticeListModal);